import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: '404',
    meta: {
      title: '404 - Stránka nenalezena',
    },
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
  },
  {
    path: '*',
    name: '503-maintenance',
    meta: {
      title: 'Technická odstávka',
    },
    component: () => import(/* webpackChunkName: "503" */ '@/views/503Maintenance.vue'),
  },
  {
    path: '/f5-test',
    name: 'f5',
    meta: {
      title: 'F5 - zablokovaný požadavek',
    },
    component: () => import(/* webpackChunkName: "f5" */ '@/views/F5.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Přihlášení',
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Distribuční portál',
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
  },
  {
    path: '/arrange',
    meta: {
      name: '_arrange',
      title: 'Potřebuji zařídit',
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "emptyRouterView" */ '@/views/EmptyRouterView.vue'),
    children: [
      {
        path: '/arrange',
        name: 'arrange',
        component: () => import(/* webpackChunkName: "arrange" */ '@/views/NeedToArrange.vue'),
        meta: {
          name: 'arrange',
          title: 'Potřebuji zařídit',
          requiresAuth: true,
        },
      },
      {
        path: 'users',
        component: () => import(/* webpackChunkName: "emptyRouterView" */ '@/views/EmptyRouterView.vue'),
        meta: {
          name: '_users',
          parent: 'arrange',
          title: 'Administrace uživatelů',
          requiresAuth: true,
          roles: ['ROLE_ADMIN'],
        },
        children: [
          {
            path: '/arrange/users',
            name: 'users',
            component: () => import(/* webpackChunkName: "users" */ '@/views/users/Users.vue'),
            meta: {
              name: 'users',
              parent: 'arrange',
              title: 'Administrace uživatelů',
              requiresAuth: true,
              roles: ['ROLE_ADMIN'],
            },
          },
          {
            path: 'add',
            name: 'users.add',
            meta: {
              parent: 'users',
              title: 'Nový uživatel',
              requiresAuth: true,
              roles: ['ROLE_ADMIN'],
            },
            component: () => import(/* webpackChunkName: "userAdd" */ '@/views/users/UserAdd.vue'),
          },
          {
            path: ':id/edit',
            name: 'users.edit',
            meta: {
              parent: 'users',
              title: 'Editace uživatele',
              requiresAuth: true,
              roles: ['ROLE_ADMIN'],
            },
            component: () => import(/* webpackChunkName: "userEdit" */ '@/views/users/UserEdit.vue'),
          },
        ],
      },
      {
        path: 'requests',
        component: () => import(/* webpackChunkName: "emptyRouterView" */ '@/views/EmptyRouterView.vue'),
        meta: {
          name: '_requests',
          parent: 'arrange',
          title: 'Moje požadavky',
          requiresAuth: true,
        },
        children: [
          {
            path: '/arrange/requests',
            name: 'requests',
            meta: {
              parent: 'arrange',
              title: 'Přehled požadavků',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "requests" */ '@/views/requests/RequestsAll.vue'),
          },
          {
            path: ':id',
            name: 'requests.detail',
            meta: {
              parent: 'requests',
              title: 'Detail požadavku',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "requestDetail" */ '@/views/requests/RequestDetail.vue'),
          },
        ],
      },
      {
        path: 'collection-point',
        component: () => import(/* webpackChunkName: "emptyRouterView" */ '@/views/EmptyRouterView.vue'),
        meta: {
          name: '_collectionPoint',
          parent: 'arrange',
          title: 'Informace o odběrném místě',
          requiresAuth: true,
          props: {
            ean: false,
            error: false,
          },
        },
        children: [
          {
            path: '/arrange/collection-point/ean/:ean?',
            name: 'collectionPoint',
            meta: {
              parent: 'arrange',
              title: 'Informace o odběrném místě',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "collectionPoint" */ '@/views/collection-points/CollectionPointInformation.vue'),
          },
          {
            path: ':ean/collection-point',
            name: 'collectionPoint.detail',
            meta: {
              parent: 'collectionPoint',
              title: 'Informace o odběrném místě',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "collectionPointDetail" */ '@/views/collection-points/Detail.vue'),
          },
          {
            path: 'report',
            name: 'reportReading',
            meta: {
              parent: 'arrange',
              title: 'Nahlášení odečtu',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "reportReading" */ '@/views/report-reading/ReportReading.vue'),
          },
          {
            path: ':ean/report',
            name: 'reportReading.detail',
            meta: {
              parent: 'reportReading',
              title: 'Nahlášení odečtu',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "reportReadingDetail" */ '@/views/report-reading/Detail.vue'),
          },
          {
            path: 'distribution',
            name: 'interruptionOrRenewalOfDistribution',
            meta: {
              parent: 'arrange',
              title: 'Přerušení / obnovení distribuce elektřiny',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "interruptionOrRenewalOfDistribution" */ '@/views/distribution/InterruptionOrRenewalOfDistribution.vue'),
          },
          {
            path: ':ean/distribution',
            name: 'interruptionOrRenewalOfDistribution.detail',
            meta: {
              parent: 'interruptionOrRenewalOfDistribution',
              title: 'Přerušení / obnovení distribuce elektřiny',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "interruptionOrRenewalOfDistributionDetail" */ '@/views/distribution/Detail.vue'),
          },
          {
            path: 'trial-operation',
            name: 'trialOperation',
            meta: {
              parent: 'arrange',
              title: 'Zkušební provoz',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "trialOperation" */ '@/views/trial-operation/TrialOperation.vue'),
          },
          {
            path: ':ean/trial-operation',
            name: 'trialOperation.detail',
            meta: {
              parent: 'trialOperation',
              title: 'Zkušební provoz',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "trialOperation" */ '@/views/trial-operation/Detail.vue'),
          },
          {
            path: 'billing-exception',
            name: 'billingException',
            meta: {
              parent: 'arrange',
              title: 'Výjimka z fakturace',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "billingException" */ '@/views/billing-exception/BillingException.vue'),
          },
          {
            path: ':ean/billing-exception',
            name: 'billingException.detail',
            meta: {
              parent: 'billingException',
              title: 'Výjimka z fakturace',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "billingException" */ '@/views/billing-exception/Detail.vue'),
          },
          {
            path: 'request-VN',
            name: 'requestVN',
            meta: {
              parent: 'arrange',
              title: 'Žádost VN',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "requestVN" */ '@/views/requests/request-vn/RequestVN.vue'),
          },
          {
            path: ':ean/request-VN',
            name: 'requestVN.detail',
            meta: {
              parent: 'requestVN',
              title: 'Žádost VN',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "requestVN" */ '@/views/requests/request-vn/Detail.vue'),
          },
          {
            path: 'agreement-attachment',
            name: 'agreementAttachment',
            meta: {
              parent: 'arrange',
              title: 'Přílohy rámcových smluv',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "agreementAttachment" */ '@/views/AgreementAttachment.vue'),
          },
          {
            path: 'request-NN',
            name: 'requestNN',
            meta: {
              parent: 'arrange',
              title: 'Žádost NN',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "requestNN" */ '@/views/requests/request-nn/RequestNN.vue'),
          },
          {
            path: ':ean/request-NN',
            name: 'requestNN.detail',
            meta: {
              parent: 'requestNN',
              title: 'Žádost NN',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "requestNNDetail" */ '@/views/requests/request-nn/Detail.vue'),
          },
          {
            path: 'update-contracts',
            name: 'updateFrameworkContractsVN',
            meta: {
              parent: 'arrange',
              // title: 'Aktualizace RSD VN',
              title: 'Změna rezervované kapacity',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "updateFrameworkContractsVN" */ '@/views/update-contracts/UpdateFrameworkContractsVN.vue'),
          },
          {
            path: ':ean/update-contracts-capacity',
            name: 'changeOfReservedCapacity.detail',
            meta: {
              parent: 'updateFrameworkContractsVN',
              // title: 'Aktualizace RSD VN',
              title: 'Změna rezervované kapacity',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "changeOfReservedCapacityDetail" */ '@/views/capacity/Detail.vue'),
          },
          {
            path: ':ean/update-contracts-stages',
            name: 'changeOfControlStages.detail',
            meta: {
              parent: 'updateFrameworkContractsVN',
              title: 'Aktualizace RSD VN',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "changeOfControlStages" */ '@/views/control-stages/Detail.vue'),
          },
          {
            path: ':ean/update-contracts-power',
            name: 'changeOfReservedPower.detail',
            meta: {
              parent: 'updateFrameworkContractsVN',
              title: 'Aktualizace RSD VN',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "changeOfReservedPower" */ '@/views/power/Detail.vue'),
          },
          {
            path: ':ean/update-contracts-other',
            name: 'otherChanges.detail',
            meta: {
              parent: 'updateFrameworkContractsVN',
              title: 'Aktualizace RSD VN',
              requiresAuth: true,
            },
            component: () => import(/* webpackChunkName: "otherChanges" */ '@/views/other/Detail.vue'),
          },
        ],
      },
      {
        path: '/planned-outage',
        name: 'plannedOutage',
        meta: {
          parent: 'arrange',
          title: 'Plánované bezproudí',
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "plannedOutage" */ '@/views/PlannedOutage.vue'),
      },
      {
        path: 'update-contracts-nn',
        name: 'updateFrameworkContractsNN',
        meta: {
          parent: 'arrange',
          title: 'Aktualizace RSD NN',
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "updateFrameworkContractsNN" */ '@/views/update-contracts/UpdateFrameworkContractsNN.vue'),
      },

    ],
  },
  {
    path: '/my-profile',
    name: 'myProfile',
    meta: {
      title: 'Nastavení mého profilu',
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "myProfile" */ '@/views/MyProfile.vue'),
  },
  {
    path: '/account-overview',
    component: () => import(/* webpackChunkName: "emptyRouterView" */ '@/views/EmptyRouterView.vue'),
    meta: {
      title: 'Moje požadavky',
      requiresAuth: true,
    },
    children: [
      {
        path: '/account-overview',
        name: 'accountOverview',
        meta: {
          title: 'Moje požadavky',
          requiresAuth: true,
        },
        component: () => import(/* webpackChunkName: "accountOverview" */ '@/views/AccountOverview.vue'),
      },
    ],
  },
];

// eslint-disable-next-line
const scrollBehavior = (to, from, savedPosition) => {
  return {
    x: 0,
    y: 0,
  };
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const localStore = JSON.parse(localStorage.getItem('store'));
    if (!localStore || !localStore.accessToken) {
      next({
        name: 'login',
      });
      return;
    }
    if (to.matched.some((record) => record.meta.roles)) {
      const { roles } = to.meta;
      const userRoles = localStore.user.authorities;
      const hasAccess = roles.reduce((found, item) => found || userRoles.includes(item), false);

      if (hasAccess) {
        next();
      } else {
        next({
          name: 'home',
        });
      }
      return;
    }

    next();
  }

  next();
});

router.afterEach((to) => {
  document.title = to.meta.title;
  store.dispatch('requests/cancel_pending_requests');
});

export default router;
